import { CodeHighlight } from '@ui/general';
import React from 'react';
export const Formula = ({ formula }) => {
    if (!formula || !formula.code) {
        return null;
    }
    return React.createElement(CodeHighlight, { code: formula.code, codeReferences: formula.codeReferences, index: -1, isNested: true });
};
